import { useEffect, useRef, useState } from "react";
import type { CallPanelView } from "./useBoardCallSplit";

/**
 * Зелёный индикатор на кнопке «Звонок».
 * Работает и без postMessage от SFU: гаснет после выхода (перезагрузка iframe) или разворота панели.
 */
export function useCallLiveIndicator(
  callView: CallPanelView,
  embedInCall: boolean | null,
  callEnded: boolean,
  resetEmbedState: () => void,
  markCallEngaged: () => void
): boolean {
  const backgrounded = callView === "minimized" || callView === "hidden";
  const [choseBackground, setChoseBackground] = useState(false);
  const prevViewRef = useRef<CallPanelView>(callView);

  useEffect(() => {
    const prev = prevViewRef.current;
    prevViewRef.current = callView;

    if (callView === "minimized" || callView === "hidden") {
      setChoseBackground(true);
      markCallEngaged();
      return;
    }

    if (callView === "closed") {
      setChoseBackground(false);
      resetEmbedState();
      return;
    }

    if (callView === "docked") {
      setChoseBackground(false);
      if (prev === "closed" || prev === "minimized" || prev === "hidden") {
        resetEmbedState();
      }
    }
  }, [callView, resetEmbedState, markCallEngaged]);

  if (!backgrounded || !choseBackground || callEnded) return false;
  return embedInCall === true || embedInCall === null;
}
